import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tab } from './components/Tab';
import { IconCase, IconFeed, IconHelp, IconIdeas } from './components/Icons';
import { Container } from './styles';
import { Box } from '@utex/ui-kit';

export interface Props {
  onFeedClick: () => void;
  onIdeasClick: () => void;
  onPortfolioClick: () => void;
  activeTab?: 'feed' | 'ideas' | 'portfolio' | 'help';
  isFeedVisible: boolean;
  zeButtonClick: () => void;
}
declare global {
  interface Window {
    zE: (ns: string, cmd: string) => void | undefined;
  }
}

export function Tabbar(props: Props) {
  const { t } = useTranslation('tabbar');
  const { isFeedVisible, onFeedClick, onIdeasClick, onPortfolioClick, activeTab } = props;

  const onHelpClick = () => {
    const { zE } = window;
    if (!zE) {
      return;
    }
    // classic version
    try {
      zE('webWidget', 'open');
    } catch (e) {}
    // new version
    try {
      const isOpened = window.sessionStorage.getItem('ZD-widgetOpen') === 'true';
      zE('messenger', isOpened ? 'close' : 'open');
    } catch (e) {}
  };

  return (
    <>
      <Container {...props}>
        <Box display="flex" justifyContent="center">
          {isFeedVisible && (
            <Tab
              onClick={onFeedClick}
              isActive={activeTab === 'feed'}
              text={t('Feed')}
              icon={<IconFeed />}
            />
          )}
          <Tab
            onClick={onIdeasClick}
            isActive={activeTab === 'ideas'}
            text={t('Ideas')}
            icon={<IconIdeas />}
          />
          <Tab
            onClick={onPortfolioClick}
            isActive={activeTab === 'portfolio'}
            text={t('Case')}
            icon={<IconCase />}
          />
          <Tab
            as="button"
            isActive={activeTab === 'help'}
            onClick={onHelpClick}
            text={t('Help')}
            icon={<IconHelp />}
          />
        </Box>
      </Container>
    </>
  );
}
